const gridSize = 10;
export function grid_fitVector(v) {
    return {
        x: Math.round(v.x / gridSize) * gridSize,
        y: Math.round(v.y / gridSize) * gridSize,
    };
}
export function grid_fitValue(val) {
    return Math.round(val / gridSize) * gridSize;
}
